export default __webpack_public_path__ + "static/media/complementary--soft-shoulder--g2.7ca975f6.png";